/**
 * Logger Interface
 *
 * Minimal logger interface used by utility functions.
 * This allows the same utilities to work with different
 * logging implementations (NestJS Logger, console, etc.)
 */

/**
 * Minimal logger interface for utility functions
 */
export interface Logger {
  warn(message: string): void;
  error?(message: string): void;
  debug?(message: string): void;
  log?(message: string): void;
}

/**
 * No-op logger for use in contexts where logging is not needed
 */
export const noopLogger: Logger = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  warn() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  error() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  debug() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  log() {},
};

/**
 * Console logger - simple wrapper around console
 */
export const consoleLogger: Logger = {
  warn: msg => console.warn(msg),
  error: msg => console.error(msg),
  debug: msg => console.debug(msg),
  log: msg => console.log(msg),
};
